module.exports = __webpack_public_path__ + "img/sally-logo-full.52de4186.svg";